'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultTunnel = undefined;

var _immutable = require('immutable');

var _reduxClientHandoffAction = require('@wh/redux-client-handoff-action');

// Types
var defaultTunnelObject = {
    metrics: {
        getUrlSegment: function getUrlSegment() {
            return {
                close: function close() {},
                getTrace: function getTrace() {
                    return -1;
                }
            };
        }
    },
    log: console
};

var TunnelRecord = (0, _immutable.Record)({
    metrics: undefined,
    log: undefined
});

var defaultTunnel = exports.defaultTunnel = new TunnelRecord(defaultTunnelObject);

/**
 * The tunnel reducer. On the server the reducer gets passed by the tunnel information composed on the restify http
 * server. On the client we use the defaultTunnel.
 * @param {Object} state The tunnel Object
 * @param {Action} action The action emitted
 * @returns {Object} The server composed tunnel or the default tunnel
 */
var tunnelReducer = function tunnelReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTunnel;
    var action = arguments[1];

    if ((0, _reduxClientHandoffAction.isClientHandOffAction)(action)) {
        return defaultTunnel;
    }
    return state;
};

exports.default = tunnelReducer;
//# sourceMappingURL=reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-tunnel/dist/main/reducer.js
// module id = 267
// module chunks = 0